<template>
  <div class="top-nav">
    <lotsHeader
      ref="lotsHeaderRef"
      class="top-nav-header"
      :is-show-tenant="false"
      :is-show-tags-view="false"
      :is-show-lang="false"
      :is-show-apps="false"
      :is-show-mes="false"
      :user-offset-y="10"
      :file-offset-y="5"
    >
      <!-- :is-show-tenant="false" tenant-position="dropdown" :more-drop-down="[
        {
          command: 'changePhoneNum',
          text: '修改手机号',
          callback: (res) => {
            changePhoneNumFn();
          },
        },
      ]" -->
      <template #before-icons>
        <div v-if="showAliVerIfNeed && aliVertBtnVisible" class="ali-phone-vert">
          <md-button type="text" size="small" @click="openAliVertDialog">虚拟号码拨打人员实名认证链接</md-button>
        </div>
        <div v-if="showWorkbenchIfNeed" class="workbench">
          <md-button type="text" size="small" @click="toWorkbench">工作台</md-button>
        </div>
        <app />
        <div v-if="handleShowAppDownload()" class="app-download" @click="openAppDownloadDialog">
          <img src="@/assets/app.png" class="app-img" />
        </div>
        <magic-msg-box
          :offset-y="5"
          :tab-labels="{
            // all: '全部', // 默认：全部
            // messages: '消息', // 默认：消息
            notice: '公告', // 默认：活动
          }"
          :notice-page-size="100"
          show-top-flag>
        </magic-msg-box>
      </template>
      <template #after-icons>
        <dispatcher />
      </template>
      <template #userDefaultIcon>
        <user-icon />
      </template>
    </lotsHeader>
  </div>
  <app-download-dialog v-model:visible="appDownloadVisiable"></app-download-dialog>
  <ali-phone-vert-dialog
    v-if="showAliVerIfNeed"
    ref="aliPhoneVertRef"
    @enableChange="(val: boolean) => (aliVertBtnVisible = val)"
  />
  <!-- <modify-phone-num v-model:dialogVisible="dialogVisible" @update:dialogVisible="changeDialogVisible" /> -->
</template>

<script setup lang="ts">
import { MagicMsgBox } from '@annto/ui';
import { ref, computed } from 'vue';
import Dispatcher from './Dispatcher/index.vue';
import UserIcon from './UserIcon/index.vue';
import App from './app/Index.vue';
import appDownloadDialog from '@/components/appDownloadDialog/index.vue';
import AliPhoneVertDialog from '@/components/aliPhoneVertDialog/index.vue';
import { useStore } from 'vuex';
import { toWorkbench } from '@/utils';
// import ModifyPhoneNum from './ModifyPhoneNum';

const lotsHeaderRef = ref<HTMLElement | null>(null);
// const dialogVisible = ref(false);
// const changePhoneNumFn = () => {
//   dialogVisible.value = true;
// };
// const changeDialogVisible = (val: boolean) => {
//   dialogVisible.value = val;
// };
const appDownloadVisiable = ref(false);
const store = useStore();
const aliVertBtnVisible = ref(false);
const aliPhoneVertRef = ref();

// 计算属性：判断是否需要显示阿里虚拟号码认证
const showAliVerIfNeed = computed(() => {
  const { curRole, roleList } = store.state;
  const roleItem = roleList.find((item: { roleCode: any }) => item.roleCode === curRole);
  let flag = false;
  if (
    roleItem &&
    ['EL-调度员', 'EL-调度员二期', 'EL-订单员', 'EL-供应商', 'ELS-履约(城配/大物流)'].includes(roleItem.roleName)
  ) {
    flag = true;
  }
  return flag;
});
// 判断是否显示工作台
const showWorkbenchIfNeed = computed(() => {
  const { curRole, roleList } = store.state;
  const roleItem = roleList.find((item: { roleCode: any }) => item.roleCode === curRole);
  if (roleItem) {
    if (
      roleItem.userCode.toLocaleLowerCase().indexOf('hc') < 0 &&
      roleItem.userCode.toLocaleLowerCase().indexOf('hp') < 0
    ) {
      //当前账号不是供应商类别
      return true;
    }
  }
  return false;
});
const openAppDownloadDialog = () => {
  appDownloadVisiable.value = true;
};
// 打开阿里虚拟号码认证链接
const openAliVertDialog = () => {
  if (aliPhoneVertRef.value) {
    aliPhoneVertRef.value.show();
  }
};
const handleShowAppDownload = () => {
  const { curRole, roleList } = store.state;
  const roleItem = roleList.find((item: { roleCode: any }) => item.roleCode === curRole);
  let flag = false;
  if (roleItem && ['EL-调度员', 'EL-调度员二期'].includes(roleItem.roleName)) {
    flag = true;
  }
  return flag;
};
</script>

<style lang="less" scoped>
body {
  .md-popper {
    .md-dropdown-menu__item {
      line-height: 28px;
      a {
        display: block;
        width: 100%;
      }
      &:hover {
        background-color: #f2f3f5;
      }
      &:active {
        color: var(--md-color-primary);
        background-color: #fff;
      }
    }
  }
}

.top-nav .lots-header .header-icon-button .md-button--text {
  height: auto;
}
.top-nav {
  .app-download {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    .app-img {
      cursor: pointer;
      width: 25px;
      height: 25px;
      border-radius: 6px;
    }
  }
  .ali-phone-vert {
    .md-button--text {
      color: #8e97a3;
      padding: 0px;
      &:hover {
        color: #2d3138;
      }
    }
  }
  .workbench {
    .md-button--text {
      color: #4285f5;
      padding: 0px;
      &:hover {
        color: #409eff;
      }
    }
  }
  .top-nav-header {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;

    ::v-deep .md-badge__content {
      font-size: 10px;
      padding: 0 5px;
      height: 16px;
      line-height: 16px;
    }

    ::v-deep .lots-message-box,
    ::v-deep .lots-upload-list {
      width: 32px;
      height: 32px;
      display: inline-block;
      line-height: 32px;
      text-align: center;
      background-color: #fff;
      border-radius: 50%;

      .upload-list-btn {
        margin-top: -4px;
        color: #8e97a3;
        &:hover {
          color: #2d3138;
          .lots-icon {
            color: #2d3138;
          }
        }
        &:active {
          color: #292d35;
        }
        .md-badge__content.is-fixed {
          top: 2px;
          right: calc(-1px + var(--md-badge-size) / 2);
        }
      }
      ::v-deep .lots-notice-tips .notice-tips-dot-btn:active {
        background: none;
      }
      ::v-deep .lots-message-box {
        ::v-deep .lots-notice-tips .notice-tips-dot-btn:active {
          background: none;
        }
      }
      &:hover {
        background-color: #f7f8fa;
        svg {
          fill: #22262e;
          &.folder-icon {
            stroke: #22262e;
          }
        }
      }
      &:active {
        background-color: #e5e6eb;
      }
      .upload-list-btn {
        padding: 0;
      }
    }

    ::v-deep .header-icon-button {
      display: flex;
      height: 50px;
      align-items: center;
      gap: 20px;
      .md-button--text {
        height: auto;
        .icon-topbar_news_medium {
          width: 32px;
          height: 32px;
          display: inline-block;
          line-height: 32px;
          text-align: center;
          background-color: #fff;
          border-radius: 50%;
          cursor: pointer;
          &:hover {
            background-color: #f7f8fa;
            svg {
              fill: #22262e;
              &.folder-icon {
                stroke: #22262e;
              }
            }
          }
          &:active {
            background-color: #e5e6eb;
          }
        }
      }
    }
  }
}
</style>
